import { WA_ADMIN } from "@/lib/api";
import { MessageCircle } from "lucide-react";

export const WhatsAppFloat = () => (
  <a
    data-testid="wa-float-btn"
    href={`https://wa.me/${WA_ADMIN}?text=${encodeURIComponent("Halo Admin Travele, saya ingin bertanya.")}`}
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 font-semibold text-black shadow-lg transition-transform hover:-translate-y-1"
  >
    <MessageCircle className="h-5 w-5" />
    <span className="hidden sm:inline">Chat Admin</span>
  </a>
);
